/* eslint-disable array-callback-return */
/* eslint-disable func-names */
import React, {
  useState,
  useCallback,
  Dispatch,
  SetStateAction,
  useEffect,
} from 'react';
import { Paper, TablePagination } from '@material-ui/core';
import { SortEndHandler } from 'react-sortable-hoc';
import useStyles from './styles';
import { SortableList } from './components/SortableList';

export interface ISortColumnData {
  isActive: boolean;
  sortDirection: 'asc' | 'desc';
}
interface ITableDragDropProps {
  items: ITitle[];
  sortColumnData: ISortColumnData;
  sortTitlesByColumn: (field: string) => void;
  writers: IUser[];
  onSortEnd: SortEndHandler;
  rowsPerPageOptions: (
    | number
    | {
        value: number;
        label: string;
      }
  )[];
  count: number;
  rowsPerPage: number;
  page: number;
  onChangePage: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    page: number,
  ) => void;
  onChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  setFilterSearchText: (value: string) => void;
  searchText: string;
  setSearchText: Dispatch<SetStateAction<string>>;
  refreshTitles: (showBackdrop?: boolean) => Promise<void>;
  filterStatus: number | null;
  permissions: IPermission;
  sitesList: string[];
  loading?: boolean;
  onOpenUpdateDrawer?: (id: string) => void;
  displayToolbar: boolean;
  setDisplayToolbar: Dispatch<SetStateAction<boolean>>;
  selectedItems: Map<string, ITitle>;
  setSelectedItems: Dispatch<SetStateAction<Map<string, ITitle>>>;
}

export const TableDragDrop: React.FC<ITableDragDropProps> = ({
  items,
  sortColumnData,
  sortTitlesByColumn,
  writers,
  onSortEnd,
  rowsPerPageOptions,
  count,
  rowsPerPage,
  page,
  onChangePage,
  onChangeRowsPerPage,
  setFilterSearchText,
  searchText,
  setSearchText,
  refreshTitles,
  filterStatus,
  permissions,
  sitesList,
  loading,
  onOpenUpdateDrawer,
  displayToolbar,
  setDisplayToolbar,
  selectedItems,
  setSelectedItems,
}) => {
  const classes = useStyles();
  // const [selectedItems, setSelectedItems] = useState(new Map<string, ITitle>());
  const [selectedAllItems, setSelectedAllItems] = useState(false);
  const [countItemsSelected, setCountItemsSelected] = useState(0);

  const getWriterName = (writerId = '', writers: IUser[] = []) => {
    const writer = writers.find((writer) => writer.id === writerId);
    return writer ? writer.name : '';
  };

  const debounce = (fn: (...args: any[]) => any, delay: number) => {
    let timeoutId: any;
    return function (...args: any) {
      clearInterval(timeoutId);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      timeoutId = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceCallback = useCallback(
    debounce((value) => {
      setFilterSearchText(value);
    }, 1000),
    [],
  );

  const handleSearchText = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setSearchText(value);
    debounceCallback(value);
  };

  const clearSearchText = () => {
    setSearchText('');
    setFilterSearchText('');
  };

  const handleCheckbox = (isChecked: boolean, value: ITitle) => {
    if (isChecked) selectedItems.set(value.id, value);
    else if (selectedItems.get(value.id)) selectedItems.delete(value.id);

    setCountItemsSelected(selectedItems.size);
    setDisplayToolbar(selectedItems.size > 0);
  };

  const handleSelectAllCheckbox = (isChecked: boolean) => {
    if (isChecked) {
      items.map((item) => {
        if (!selectedItems.get(item.id)) selectedItems.set(item.id, item);
      });
    } else {
      items.map((item) => {
        if (selectedItems.get(item.id)) selectedItems.delete(item.id);
      });
    }
    setDisplayToolbar(selectedItems.size > 0);
    setSelectedAllItems(isChecked);
  };

  const clearSelectedCheckboxes = () => {
    setDisplayToolbar(false);
    setSelectedAllItems(false);
    setSelectedItems(new Map<string, ITitle>());
  };

  useEffect(() => {
    clearSelectedCheckboxes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  return (
    <Paper>
      <SortableList
        classes={classes}
        pressDelay={150}
        lockAxis="y"
        items={items}
        sortColumnData={sortColumnData}
        sortTitlesByColumn={sortTitlesByColumn}
        writers={writers}
        onSortEnd={onSortEnd}
        searchText={searchText}
        handleSearchText={handleSearchText}
        clearSearchText={clearSearchText}
        getWriterName={getWriterName}
        refreshTitles={refreshTitles}
        handleCheckbox={handleCheckbox}
        isAllCheckboxesSelected={selectedAllItems}
        handleSelectAllCheckbox={handleSelectAllCheckbox}
        clearSelectedCheckboxes={clearSelectedCheckboxes}
        useWindowAsScrollContainer
        displayToolbar={displayToolbar}
        selectedItems={selectedItems}
        selectedAllItems={selectedAllItems}
        disableAutoscroll={false}
        countItemsSelected={countItemsSelected}
        refetchTitles={refreshTitles}
        filterStatus={filterStatus}
        permissions={permissions}
        sitesList={sitesList}
        loading={loading}
        onOpenUpdateDrawer={onOpenUpdateDrawer}
      />
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
      />
    </Paper>
  );
};

TableDragDrop.defaultProps = {
  loading: false,
};
